import Layout from './components/layout';
import ContractDetailsDailog from './components/ContractDetailsDailog';

export default {
	Layout,
	ContractDetailsDailog
}